import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ntHeroSlides } from "@/mocks/newtechData";
import { useBanners } from "@/hooks/useSupabaseData";

export default function NTHero() {
  const [current, setCurrent] = useState(0);
  const { banners, loading } = useBanners();

  const slides =
    banners.length > 0
      ? banners.map((b) => ({
          id: b.id,
          tag: b.subtitle ?? "NEW TECH",
          title: b.title,
          subtitle: "",
          cta1: b.cta_label ?? "Conheça Nossas Soluções",
          cta2: "Fale com um Especialista",
          image: b.image_url ?? ntHeroSlides[0].image,
        }))
      : ntHeroSlides;

  useEffect(() => {
    if (slides.length === 0) return;
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 8000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const prev = () =>
    setCurrent((c) => (c - 1 + slides.length) % slides.length);
  const next = () =>
    setCurrent((c) => (c + 1) % slides.length);

  if (loading) {
    return (
      <section className="relative w-full h-[580px] md:h-[680px] bg-gray-100 animate-pulse" />
    );
  }

  return (
    <section className="relative w-full h-[580px] md:h-[680px] overflow-hidden bg-white">
      {slides.map((slide, idx) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            idx === current ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-white/80 via-white/40 to-transparent"></div>
        </div>
      ))}

      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-6 w-full">
          <div className="max-w-xl">

            <div className="inline-flex items-center gap-2 mb-4">
              <div className="w-6 h-px bg-[#1B1F5E]"></div>
              <span className="text-[#1B1F5E] font-bold text-xs tracking-widest uppercase">
                {slides[current]?.tag}
              </span>
            </div>

            <h1 className="font-rajdhani font-bold text-[#1a1a1a] text-4xl md:text-5xl leading-tight mb-4">
              {slides[current]?.title}
            </h1>

            {slides[current]?.subtitle && (
              <p className="font-inter text-[#555] text-base leading-relaxed mb-8">
                {slides[current].subtitle}
              </p>
            )}

            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/servicos"
                className="inline-flex items-center justify-center gap-2 bg-[#1B1F5E] hover:bg-[#2F4F8F] text-white font-bold px-7 py-3.5 rounded-md transition-colors whitespace-nowrap text-sm"
              >
                {slides[current]?.cta1}
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>

              <Link
                to="/contato"
                className="inline-flex items-center justify-center gap-2 border-2 border-[#1B1F5E] text-[#1B1F5E] hover:bg-[#1B1F5E] hover:text-white font-bold px-7 py-3.5 rounded-md transition-all whitespace-nowrap text-sm"
              >
                {slides[current]?.cta2}
              </Link>
            </div>

          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 flex items-center justify-center bg-white/80 hover:bg-[#1B1F5E] hover:text-white text-[#333] rounded-full transition-all"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>

      <button
        onClick={next}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 flex items-center justify-center bg-white/80 hover:bg-[#1B1F5E] hover:text-white text-[#333] rounded-full transition-all"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {slides.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`transition-all rounded-full ${
              idx === current
                ? "w-8 h-2 bg-[#1B1F5E]"
                : "w-2 h-2 bg-[#1B1F5E]/30 hover:bg-[#1B1F5E]/60"
            }`}
          />
        ))}
      </div>

      <div className="absolute bottom-0 right-0 z-20 hidden lg:flex">
        <div className="bg-[#1B1F5E] px-8 py-4 flex items-center gap-8">
          {[{ num: "10+", label: "Anos" }, { num: "200+", label: "Projetos" }, { num: "5", label: "Segmentos" }].map((s) => (
            <div key={s.label} className="flex items-center gap-2">
              <span className="font-rajdhani font-bold text-white text-2xl leading-none">{s.num}</span>
              <span className="text-white/80 text-xs">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}